import ShMoreButton from './src/main.vue'

ShMoreButton.install = function (Vue) {
  Vue.component(ShMoreButton.name, ShMoreButton)
}

export default ShMoreButton
